import { Component } from '@angular/core';
import { NoRecordComponent } from "../no-record/no-record.component";
import { RouterModule } from '@angular/router';


@Component({
    selector: 'app-error-page',
    imports: [
    RouterModule
],
    templateUrl: './error-page.component.html',
    styleUrl: './error-page.component.css'
})
export class ErrorPageComponent {

}
